import React from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from 'react-intl';

import defaultSourceLogo from "./source.svg";
import defaultDestinationLogo from "./destination.svg";
import goSendPickupLogo from "./go-send-pickup.svg"
import goSendDropLogo from "./go-send-drop.svg"
import separator from "./separator.svg";
import missingAddress from "./missing-address.svg";
import separatorVertical from "./separator-vertical.svg"
import './style.scss';

export default class SourceAndDestination extends React.Component {
  static propTypes = {
    serviceType: PropTypes.string.isRequired,
    sourceName: PropTypes.string.isRequired,
    sourceAddress: PropTypes.string.isRequired,
    destinationName: PropTypes.string,
    destinationAddress: PropTypes.string,
    isCardOpen: PropTypes.bool,
    isGoSendPartnerOrder: PropTypes.bool,
    isDesktopView: PropTypes.bool,
  };

  static serviceTypeSourceLogoMap = {
    "go-kilat-new": goSendPickupLogo,
    "sameday-kilat": goSendPickupLogo,
    "instant-mpmd": goSendPickupLogo,
    "go-send-instant-2w": goSendPickupLogo,
  };

  static serviceTypeDestinationLogoMap = {
    "go-kilat-new": goSendDropLogo,
    "sameday-kilat": goSendDropLogo,
    "instant-mpmd": goSendDropLogo,
    "go-send-instant-2w": goSendDropLogo,
  };

  static serviceTypeSourceLabelMap = {
    "go-kilat-new": "Sender",
  };

  static serviceTypeDestinationLabelMap = {
    "go-kilat-new": "Recipient",
  };

  getSourceLogo() {
    let sourceLogo = SourceAndDestination.serviceTypeSourceLogoMap[this.props.serviceType];
    return sourceLogo ? sourceLogo : defaultSourceLogo;
  }

  getDestinationLogo() {
    let destinationLogo = SourceAndDestination.serviceTypeDestinationLogoMap[this.props.serviceType];
    return destinationLogo ? destinationLogo : defaultDestinationLogo;
  }

  getSourceLabel() {
    if(this.props.isGoSendPartnerOrder) {
      return (<FormattedMessage
        id="GoSendPartner.Source"
        />)
    }

    let sourceLabel = SourceAndDestination.serviceTypeSourceLabelMap[this.props.serviceType];
    return sourceLabel ? sourceLabel : "PICKUP";
  }

  getDestinationLabel() {
    if(this.props.isGoSendPartnerOrder) {
      return (<FormattedMessage
        id="GoSendPartner.Destination"
        />)
    }
    let destinationLabel = SourceAndDestination.serviceTypeDestinationLabelMap[this.props.serviceType];
    return destinationLabel ? destinationLabel : "DROP OFF";
  }

  getClassName() {
    const {isCardOpen,isGoSendPartnerOrder,isDesktopView} = this.props;
    let name = "SourceAndDestination"

    if(isGoSendPartnerOrder) {
      name = `${name} SwipeableCard`
    }

    if(isCardOpen || isDesktopView) {
      name = `${name} DesktopView`
    }

    return name
  }

  render() {
    const {sourceName,isGoSendPartnerOrder,destinationName} = this.props;

    if(isGoSendPartnerOrder && (!sourceName  || !destinationName)) {
      return (
        <div className="SourceAndDestination MissingAddress">
          <div className="leftColumn">
            <div className="photo">
              <img alt="Driver" src={missingAddress}/>
            </div>
          </div>
          <div className="rightColumn">
            <div className="firstLine">
              <FormattedMessage id={"GoSendPartner.Error.missingAddress.title"}/>
            </div>
            <div className="secondLine">
              <FormattedMessage id={"GoSendPartner.Error.missingAddress.message"}/>
            </div>
          </div>
        </div>
      )
    }

    return (
        <div className={this.getClassName()}>
          <div className="Source">
            <div className="leftColumn">
              <div className="photo">
                <img alt="Source" src={this.getSourceLogo()}/>
              </div>
            </div>
            <div className="rightColumn">
              <div className="title">{this.getSourceLabel()}</div>
              <div className="name">{this.props.sourceName}</div>
            </div>
          </div>

        {this.props.destinationName && this.props.destinationAddress &&
          <React.Fragment>
            <div className="separator">
              <img alt="Separator" src={this.props.isCardOpen || this.props.isDesktopView ? separatorVertical : separator} />
            </div>

            <div className="Destination">
              <div className="leftColumn">
                <div className="photo">
                  <img alt="Source" src={this.getDestinationLogo()} />
                </div>
              </div>
              <div className="rightColumn">
                <div className="title">{this.getDestinationLabel()}</div>
                <div className="name">{this.props.destinationName}</div>
              </div>
            </div>
          </React.Fragment>
        }
        </div>
    );
  }
}

